import { useState, useRef, useEffect, useCallback } from "react";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import AddressAutocomplete from "../../Components/addressInput/address-input";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { get } from "jquery";
import debounce from "lodash/debounce";
import { useSelector, useDispatch } from "react-redux";
import { FilePlus2 } from "lucide-react";

const defaultForm = {
  interaction: "",
  scope: "",
  depositType: "",
  fundingType: "",
  currency: 8,
  value: "",
  completionDate: "",
  description: "",
  otherFundType: "",
  otherClientInteractionType: "",
  otherTransactionScope: "",
  depositTypeOther: "",
  address: "",
};

export default function TransactionsSection() {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [transactions, setTransactions] = useState([]);
  const { customerId } = useParams();
  const roleName = useSelector((state) => state.user.roleName);

  const { showToast } = useToast();
  const [form, setForm] = useState(defaultForm);
  const [isOpen, setIsOpen] = useState(false);
  const [viewItem, setViewItem] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [clientInteractionType, setClientInteractionType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currencyData, setCurrencyData] = useState([]);
  const [comments, setComments] = useState("");
  const [otherFundType, setOtherFundType] = useState("");
  const [otherClientInteractionType, setOtherClientInteractionType] =
    useState("");
  const [otherTransactionScope, setOtherTransactionScope] = useState("");
  const [depositTypeOther, setDepositTypeOther] = useState("");

  const [apIAddress, setApIAddress] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 8,
    label: "AUD",
  });
  const [amount, setAmount] = useState(0);

  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  const [toCurrency, setToCurrency] = useState(8);

  const [
    preselectedClientInteractionType,
    setpreselectedClientInteractionType,
  ] = useState({});
  const getCurrentDate = () => {
    const today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset()); // Adjust for timezone
    return today.toISOString().split("T")[0]; // Get YYYY-MM-DD format
  };
  const [redAddress, setRedAddress] = useState({});
  const [creationDate, setCreationDate] = useState(getCurrentDate());
  const [clientInteractionData, setClientInteractionData] = useState([
    {
      value: 1,
      label: "Face-to-face",
    },
  ]);
  const [transactionScope, setTransactionScope] = useState(null);

  const [preselectedTransactionScope, setpreselectedTransactionScope] =
    useState({});

  const [transactionScopeData, setTransactionScopeData] = useState([
    {
      value: 1,
      label: "Face-to-face",
    },
  ]);
  const [depositType, setDepositType] = useState(null);

  const [preselectedDepositType, setpreselectedDepositType] = useState({});

  const [depositTypeData, setDepositTypeData] = useState([
    {
      value: 1,
      label: "Cash",
    },
  ]);
  const [fundingType, setFundingType] = useState(null);

  const [preselectedFundingType, setpreselectedFundingType] = useState({});

  const [fundingTypeData, setFundingTypeData] = useState([
    {
      value: 1,
      label: "Own funds",
    },
  ]);
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const PostAPIcall = async (url, payload) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error);
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const PutAPIcall = async (url, payload) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error);
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const getEnums = async () => {
    try {
      let response = "";
      response = await GetAPIcalls(`/api/v1/reference/client-deal-options`);

      if (response.status == 200) {
        const interactionData = [];
        response.data.client_deal_options.client_interactions.forEach(
          (profile) => {
            interactionData.push({
              value: profile.id,
              label: profile.name,
            });
          },
        );
        setClientInteractionData(interactionData);

        const transactionScopeData = [];
        response.data.client_deal_options.transaction_scopes.forEach(
          (profile) => {
            transactionScopeData.push({
              value: profile.id,
              label: profile.name,
            });
          },
        );
        setTransactionScopeData(transactionScopeData);

        const depositTypeData = [];
        response.data.client_deal_options.deposit_types.forEach((profile) => {
          depositTypeData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setDepositTypeData(depositTypeData);

        const fundingTypeData = [];
        response.data.client_deal_options.funding_types.forEach((profile) => {
          fundingTypeData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setFundingTypeData(fundingTypeData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {}, 100);
    }
  };
  const getCurrencies = async () => {
    try {
      let response = "";
      response = await GetAPIcalls(`/api/v1/reference/currencies?limit=200`);

      if (response.status == 200) {
        const currencyData = [];
        response.data.currencies.forEach((currency) => {
          currencyData.push({
            value: currency.id,
            label: currency.name,
          });
        });
        setCurrencyData(currencyData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {}, 100);
    }
  };
  const humanize = (val) => {
    if (!val) return "";
    return val
      .toString()
      .replace(/_/g, " ")
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  };
  const handleCancel = async (clientDealId) => {
    let toastMessage = null;
    try {
      const response = await withdrawApplicationAPI(clientDealId, "cancelled");
      if (response.status == 200) {
        getTransactions();
        toastMessage = {
          message: "Transaction cancelled successfully",
          type: "success",
        };
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const withdrawApplicationAPI = async (clientDealId, status) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl =
      roleName == "agent"
        ? `${BASE_URL}/api/v1/agent/customers/${customerId}/client-deals/${clientDealId}/status`
        : `${BASE_URL}/api/v1/agency/customers/${customerId}/client-deals/${clientDealId}/status`;
    let bodyData = {
      status: status,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleClose = async (clientDealId) => {
    let toastMessage = null;
    try {
      const response = await withdrawApplicationAPI(clientDealId, "closed");
      if (response.status == 200) {
        getTransactions();
        toastMessage = {
          message: "Transaction closed successfully",
          type: "success",
        };
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getTransactions = async () => {
    try {
      let response = "";
      response = await GetAPIcalls(
        roleName == "agent"
          ? `/api/v1/agent/customers/${customerId}/client-deals`
          : `/api/v1/agency/customers/${customerId}/client-deals`,
      );

      if (response.status == 200) {
        const items = response.data.items || [];

        const humanize = (val) => {
          if (!val) return "";
          return val
            .toString()
            .replace(/_/g, " ")
            .split(" ")
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(" ");
        };

        const mapped = items.map((it) => {
          const addr = it.deal_address || {};
          const googleAddress = addr.google_address || "";

          return {
            id: it.id,
            interaction: it.client_interaction,
            scope: it.transaction_scope,
            depositType: it.deposit_type,
            fundingType: it.funding_type,
            currency: it.currency_id ? it.currency_id : "",
            currencyName: (it.currency && it.currency.name) || "",
            currencySymbol: (it.currency && it.currency.symbol) || "",

            value:
              it.transaction_value_aud ||
              it.settlement_transaction_value_aud ||
              "0",
            completionDate:
              it.expected_completion_date || it.actual_completion_date || "",
            description: it.transaction_description || "",
            otherFundType: it.funding_type_other || "",
            otherClientInteractionType: it.client_interaction_other || "",
            otherTransactionScope: it.transaction_scope_other || "",
            depositTypeOther: it.deposit_type_other || "",
            status: it.status.name || "",
            address:
              googleAddress ||
              [addr.street_number, addr.street_name, addr.street_type]
                .filter(Boolean)
                .join(" "),
          };
        });

        setTransactions(mapped);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {}, 100);
    }
  };
  const fetchTransactionDetails = async (clientDealId) => {
    try {
      const response = await GetAPIcalls(
        roleName == "agent"
          ? `/api/v1/agent/customers/${customerId}/client-deals/${clientDealId}`
          : `/api/v1/agency/customers/${customerId}/client-deals/${clientDealId}`,
      );

      if (response.status == 200) {
        // support variations in payload shape
        const it =
          (response.data &&
            (response.data.client_deal ||
              response.data.item ||
              response.data)) ||
          response;

        const addr = it.deal_address || {};
        const googleAddress = addr.google_address || "";

        const mapped = {
          id: it.id,
          // keep enum and other separately so view can render appropriately
          interaction_enum: it.client_interaction || null,
          interaction: it.client_interaction
            ? it.client_interaction.name.replace(/_/g, " ")
            : it.client_interaction_other || "",
          scope_enum: it.transaction_scope || null,
          scope: it.transaction_scope
            ? it.transaction_scope.name.replace(/_/g, " ")
            : it.transaction_scope_other || "",
          depositType_enum: it.deposit_type || null,
          depositType: it.deposit_type
            ? it.deposit_type.name.replace(/_/g, " ")
            : it.deposit_type_other || "",
          fundingType_enum: it.funding_type || null,
          fundingType: it.funding_type
            ? it.funding_type.name.replace(/_/g, " ")
            : it.funding_type_other || "",
          symbol: (it.currency && it.currency.symbol) || "$",
          currency: (it.currency && it.currency.name) || it.currency_id || "",
          value:
            it.transaction_value_aud ||
            it.settlement_transaction_value_aud ||
            "0",
          completionDate:
            it.expected_completion_date || it.actual_completion_date || "",
          description: it.transaction_description || "",
          otherFundType: it.funding_type_other || "",
          otherClientInteractionType: it.client_interaction_other || "",
          otherTransactionScope: it.transaction_scope_other || "",
          depositTypeOther: it.deposit_type_other || "",
          address:
            googleAddress ||
            [addr.street_number, addr.street_name, addr.street_type]
              .filter(Boolean)
              .join(" ") ||
            "",
        };

        setViewItem(mapped);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message || "Failed to fetch transaction details", "error");
    }
  };
  const removeEmptyFields = (obj) => {
    const cleaned = {};

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(typeof value === "object" && Object.keys(value).length === 0)
      ) {
        cleaned[key] = value;
      }
    });

    return cleaned;
  };
  const handleSubmit = useCallback(
    debounce(async (e) => {
      e?.preventDefault();
      let toastMessage = null;
      // Basic client-side validation
      const isSelected = (fieldLabel, stateValue, preselected) => {
        return (
          (form[fieldLabel] && String(form[fieldLabel]).trim() !== "") ||
          (stateValue !== null &&
            stateValue !== undefined &&
            stateValue !== "") ||
          (preselected &&
            preselected.label &&
            String(preselected.label).trim() !== "")
        );
      };

      // Determine whether special 'Other' fields are required based on selection id or label
      const isOtherSelected = (idState, preselected, labelVal) => {
        try {
          console.log(
            "Selected :" + idState + "," + preselected + "," + labelVal,
          );

          if (idState === 3 || idState === 6 || idState === 8) return true; // common 'other' ids used by enums
          if (
            preselected &&
            (preselected.value === 3 ||
              preselected.value === 6 ||
              preselected.value === 8)
          )
            return true;
          const l = (preselected?.label || labelVal || "")
            .toString()
            .toLowerCase();
          return l.includes("other") || l.includes("other") || l === "other";
        } catch (e) {
          return false;
        }
      };

      if (
        !isSelected(
          "interaction",
          clientInteractionType,
          preselectedClientInteractionType,
        )
      ) {
        showToast("Please select Client Interaction", "error");
        return;
      }
      // if (!isSelected("scope", transactionScope, preselectedTransactionScope)) {
      //   showToast("Please select Transaction Scope", "error");
      //   return;
      // }
      // if (!isSelected("depositType", depositType, preselectedDepositType)) {
      //   showToast("Please select Deposit Type", "error");
      //   return;
      // }
      // if (!isSelected("fundingType", fundingType, preselectedFundingType)) {
      //   showToast("Please select Funding Type", "error");
      //   return;
      // }
      // if (!isSelected("currency", toCurrency, preselectedcashCurrency)) {
      //   showToast("Please select Currency", "error");
      //   return;
      // }

      // if (!redAddress.value || !form.address) {
      //   showToast("Please enter an address", "error");
      //   return;
      // }
      // const numericValue = parseFloat(form.value || amount || 0);
      // if (!numericValue || numericValue <= 0) {
      //   showToast("Please enter a valid transaction amount", "error");
      //   return;
      // }
      if (clientInteractionType == 6 && !otherClientInteractionType) {
        showToast("Please specify the client interaction (Other)", "error");
        return;
      }
      // if (transactionScope == 8 && !otherTransactionScope) {
      //   showToast("Please specify the transaction scope (Other)", "error");
      //   return;
      // }
      // if (depositType == 8 && !depositTypeOther) {
      //   showToast("Please specify the deposit type (Other)", "error");
      //   return;
      // }
      // if (fundingType == 3 && !otherFundType) {
      //   showToast("Please specify the funding type (Other)", "error");
      //   return;
      // }

      setLoading(true);

      // Build payload expected by API
      const normalizeLabel = (label) =>
        label
          ? label
              .toString()
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "_")
              .replace(/^_+|_+$/g, "")
          : null;

      const findCurrencyId = () => {
        if (currencyData && currencyData.length) {
          const found = currencyData.find(
            (c) => c.label === form.currency || c.value === form.currency,
          );
          if (found) return found.value;
        }
        return preselectedcashCurrency?.value || null;
      };

      const buildDealAddress = () => {
        const addr = (redAddress && redAddress.value) || apIAddress || null;
        if (!addr) return null;

        const keys = {
          street_number: addr.street_number || addr.number || null,
          street_name: addr.street_name || addr.street || null,
          street_type: addr.street_type || null,
          suburb: addr.suburb || addr.city || null,
          state_id: addr.state_id || addr.state_id || null,
          country_id: addr.country_id || addr.country_id || null,
          zip_code: addr.zip_code || addr.postcode || addr.postal_code || null,
          google_address:
            addr.full ||
            addr.google_address ||
            addr.label ||
            form.address ||
            null,
        };

        // Remove null-ish keys
        Object.keys(keys).forEach((k) => {
          if (keys[k] === null || keys[k] === undefined) delete keys[k];
        });

        return keys;
      };

      const currency_id = findCurrencyId();
      const transaction_value_aud = parseFloat(form.value || amount || 0) || 0;
      const formatted_value = transaction_value_aud.toFixed(2);
      const expected_completion_date =
        form.completionDate || creationDate || null;
      console.log("Form data before submission:", form);
      const rawPayload = {
        client_interaction:
          normalizeLabel(
            form.interaction?.name ||
              preselectedClientInteractionType?.label ||
              "",
          ) || null,

        client_interaction_other:
          form.otherClientInteractionType || otherClientInteractionType || null,

        transaction_scope:
          normalizeLabel(
            form.scope?.name || preselectedTransactionScope?.label || "",
          ) || null,

        transaction_scope_other:
          form.otherTransactionScope || otherTransactionScope || null,

        deposit_type:
          normalizeLabel(
            form.depositType?.name || preselectedDepositType?.label || "",
          ) || null,

        deposit_type_other: form.depositTypeOther || depositTypeOther || null,

        funding_type:
          normalizeLabel(
            form.fundingType?.name || preselectedFundingType?.label || "",
          ) || null,

        funding_type_other: form.otherFundType || otherFundType || null,

        currency_id: form.currency || toCurrency || null,

        transaction_value_aud: formatted_value,
        settlement_transaction_value_aud: formatted_value,

        expected_completion_date: expected_completion_date,
        actual_completion_date: null,

        transaction_description: form.description || comments || null,

        deal_address: buildDealAddress(),
      };
      const payload = removeEmptyFields(rawPayload);

      try {
        let response = "";
        if (editIndex !== null) {
          response = await PutAPIcall(
            roleName == "agent"
              ? `/api/v1/agent/customers/${customerId}/client-deals/${form.id}`
              : `/api/v1/agency/customers/${customerId}/client-deals/${form.id}`,
            payload,
          );
        } else {
          response = await PostAPIcall(
            roleName == "agent"
              ? `/api/v1/agent/customers/${customerId}/client-deals`
              : `/api/v1/agency/customers/${customerId}/client-deals`,
            payload,
          );
        }
        // Only update local state after successful API call
        // if (editIndex !== null) {
        //   const updated = [...transactions];
        //   updated[editIndex] = form;
        //  // setTransactions(updated);
        // } else {
        //  // setTransactions([...transactions, form]);
        // }
        if (response.status === 200 || response.status === 201) {
          getTransactions();
          // Clear form and UI state
          setForm(defaultForm);
          setEditIndex(null);
          setIsOpen(false);
          setAmount("");
          setComments("");
          setCreationDate(getCurrentDate());
          setRedAddress({});
          setApIAddress(null);
          setpreselectedClientInteractionType({});
          setpreselectedTransactionScope({});
          setpreselectedDepositType({});
          setpreselectedFundingType({});
          setpreselectedCurrency({
            value: defaultForm.currency,
            label: "AUD",
          });

          // reset other-* fields
          setOtherFundType("");
          setOtherClientInteractionType("");
          setOtherTransactionScope("");
          setDepositTypeOther("");
          // resetmain field
          setFundingType(null);
          setToCurrency(null);
          setDepositType(null);
          setTransactionScope(null);
          setClientInteractionType(null);
          showToast("Transaction saved successfully", "success");
        }
      } catch (err) {
        showToast(err.message || "Failed to save transaction", "error");
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [
      form,
      clientInteractionType,
      preselectedClientInteractionType,
      transactionScope,
      preselectedTransactionScope,
      depositType,
      preselectedDepositType,
      fundingType,
      preselectedFundingType,
      toCurrency,
      preselectedcashCurrency,
      amount,
      comments,
      creationDate,
      redAddress,
      apIAddress,
      currencyData,
      otherClientInteractionType,
      otherTransactionScope,
      depositTypeOther,
      otherFundType,
      defaultForm,
    ], // Dependencies
  );
  const handleEdit = (index) => {
    const item = transactions[index];

    setForm(item);
    setEditIndex(index);

    // Sync UI states
    setAmount(item.value || "");
    setComments(item.description || "");
    setCreationDate(item.completionDate || "");
    setRedAddress({ value: { full: item.address } });
    setOtherFundType(item.otherFundType || "");
    setOtherClientInteractionType(item.otherClientInteractionType || "");
    setOtherTransactionScope(item.otherTransactionScope || "");
    setDepositTypeOther(item.depositTypeOther || "");
    // Set preselected dropdown values
    setpreselectedClientInteractionType({
      label: item.interaction?.name || "",
      value: item.interaction?.id || "",
    });
    setpreselectedTransactionScope({
      label: item.scope?.name || "",
      value: item.scope?.id || "",
    });
    setpreselectedDepositType({
      label: item.depositType?.name || "",
      value: item.depositType?.id || "",
    });
    setpreselectedFundingType({
      label: item.fundingType?.name || "",
      value: item.fundingType?.id || "",
    });
    setpreselectedCurrency({
      label: item.currency?.name || "AUD",
      value: item.currency?.id || 8,
    });
    setToCurrency(item.currency?.id);
    //setForm({ ...form, currency: item.currency.id });
    setClientInteractionType(item.interaction?.id || null);
    setTransactionScope(item.scope?.id || null);
    setDepositType(item.depositType?.id || null);
    setFundingType(item.fundingType?.id || null);
    setIsOpen(true);
  };
  const handleSelectTransactionInteraction = (selectedOption) => {
    setForm({ ...form, interaction: selectedOption.label });
    setpreselectedClientInteractionType(selectedOption);
    setClientInteractionType(selectedOption.value);
  };

  const handleSelectTransactionScope = (selectedOption) => {
    setForm({ ...form, scope: selectedOption.label });
    setpreselectedTransactionScope(selectedOption);
    setTransactionScope(selectedOption.value);
  };

  const handleSelectDepositType = (selectedOption) => {
    setForm({ ...form, depositType: selectedOption.label });
    setpreselectedDepositType(selectedOption);
    setDepositType(selectedOption.value);
  };

  const handleSelectFundingType = (selectedOption) => {
    console.log("Selected funding type:", selectedOption);
    setForm({ ...form, fundingType: selectedOption.label });
    setpreselectedFundingType(selectedOption);
    setFundingType(selectedOption.value);
  };

  const handleSelectToCurrency = (selectedOption) => {
    setForm({ ...form, currency: selectedOption.value });
    setpreselectedCurrency(selectedOption);
    setToCurrency(selectedOption.value);
    console.log("Selected currency type:", selectedOption);
    console.log("Selected funding dddtype:", selectedOption.value);
  };
  const formatNumber = (value) => {
    if (!value) return "";

    // Remove commas before parsing
    const number = parseFloat(value.toString().replace(/,/g, ""));

    if (isNaN(number)) return "";

    // Format with 2 decimal places and add commas
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const capitalizeWords = (s) => {
    if (!s && s !== 0) return "";
    return s
      .toString()
      .split(/\s+/)
      .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : ""))
      .join(" ");
  };
  const handleAmountChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, "");

    if (!isNaN(rawValue) || rawValue === "") {
      setAmount(rawValue);
      setForm({ ...form, value: rawValue });
    }
  };
  useEffect(() => {
    getEnums();
    getCurrencies();
    getTransactions();
  }, []);
  useEffect(() => {
    if (fundingType !== 3) {
      setOtherFundType("");
      setForm({ ...form, otherFundType: "" });
    }
  }, [fundingType]);
  useEffect(() => {
    if (clientInteractionType !== 6) {
      setOtherClientInteractionType("");
      setForm({ ...form, otherClientInteractionType: "" });
    }
  }, [clientInteractionType]);
  useEffect(() => {
    if (transactionScope !== 8) {
      setOtherTransactionScope("");
      setForm({ ...form, otherTransactionScope: "" });
    }
  }, [transactionScope]);
  useEffect(() => {
    if (depositType !== 8) {
      setDepositTypeOther("");
      setForm({ ...form, otherDepositType: "" });
    }
  }, [depositType]);

  const resetFormState = () => {
    setForm(defaultForm);
    setEditIndex(null);
    setIsOpen(true);
    setAmount("");
    setComments("");
    setCreationDate(getCurrentDate());
    setRedAddress({});
    setApIAddress(null);
    setpreselectedClientInteractionType({});
    setpreselectedTransactionScope({});
    setpreselectedDepositType({});
    setpreselectedFundingType({});
    setpreselectedCurrency({ value: defaultForm.currency, label: "AUD" });
    setOtherClientInteractionType("");
    setOtherTransactionScope("");
    setDepositTypeOther("");
    setOtherFundType("");
    setFundingType(null);
    setToCurrency(null);
    setDepositType(null);
    setTransactionScope(null);
    setClientInteractionType(null);
  };
  return (
    <div className="p-6 bg-gradient-to-br from-slate-50 to-gray-100 rounded-2xl">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {/* Header Section */}
      <div className="mb-8">
        <div className="flex justify-between items-end mb-2">
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-1">
              Transactions
            </h2>
            <p className="text-sm text-slate-500">
              Manage and track transactions
            </p>
          </div>
          <button
            onClick={() => {
              resetFormState();
            }}
            className="bg-gradient-to-r from-slate-900 to-slate-700 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg hover:from-slate-800 hover:to-slate-600 transition-all duration-200 flex items-center gap-2"
          >
            <span className="text-lg">+</span> Add Transaction
          </button>
        </div>
        <div className="h-1 w-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
      </div>

      {/* List */}
      <div className="grid gap-4">
        {transactions.length === 0 ? (
          <div className="bg-white rounded-xl p-12 text-center border-2 border-dashed border-gray-300">
            <div className="text-gray-400 text-5xl mb-4">📋</div>
            <h3 className="text-gray-600 font-semibold mb-1">
              No transactions yet
            </h3>
            <p className="text-gray-500 text-sm mb-4">
              Start by adding your first transaction
            </p>
            <button
              onClick={() => {
                resetFormState();
              }}
              className="text-blue-600 font-semibold hover:text-blue-700 transition-colors"
            >
              Add Transaction
            </button>
          </div>
        ) : (
          transactions.map((t, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-blue-300 overflow-hidden group"
            >
              {/* Card Content */}
              <div className="p-5">
                <div className="flex justify-between items-start mb-4">
                  {/* Left Section */}
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-2 h-10 bg-gradient-to-b from-blue-500 to-purple-500 rounded-full"></div>
                      <div>
                        <h3 className="text-xl font-bold text-slate-900">
                          {t.currencySymbol}
                          {formatNumber(t.value)}
                        </h3>
                        <p className="text-sm text-slate-600">
                          {t.description}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 text-xs text-slate-500">
                      <span className="flex items-center gap-1">
                        📅 {t.completionDate}
                      </span>
                      <span className="flex items-center gap-1">
                        🌍 {t.currencyName}
                      </span>
                      <span className="flex items-center gap-1">
                        {t.status === "Closed" && "✅"}
                        {t.status === "Initiated" && "⏳"}
                        {t.status === "Cancelled" && "❌"}
                        {t.status}
                      </span>
                    </div>
                    {t.address && (
                      <p className="text-xs text-slate-400 mt-2 line-clamp-1">
                        📍 {t.address}
                      </p>
                    )}
                  </div>

                  {/* Right Section - Action Buttons */}
                  <div className="flex flex-wrap gap-2">
                    {/* Add Contract (Modern SaaS Style) */}
<button
  onClick={() => {
     navigate(`/create-contract/${customerId}/${t.id}`, {
                  state: {
                    from: location.pathname,
                    historyStack: [
                      ...(location.state?.historyStack || []),
                      location.pathname,
                    ],
                  },
                });
  }}
  className="flex items-center gap-1 px-3 py-2 bg-blue-50 text-[#375AE7] font-medium rounded-lg hover:bg-blue-100 hover:shadow-md transition-all duration-200 text-sm active:scale-[0.97]"
>
  <FilePlus2 size={16} />
  <span className="hidden sm:inline">Manage Contract(s)</span>
</button>
                    {/* View */}
                    <button
                      onClick={() => fetchTransactionDetails(t.id)}
                      className="flex items-center gap-1 px-3 py-2 bg-blue-50 text-blue-600 font-medium rounded-lg hover:bg-blue-100 transition-all text-sm"
                    >
                      👁️ <span className="hidden sm:inline">View</span>
                    </button>

                    {/* Edit */}
                    <button
                      onClick={() => handleEdit(index)}
                      className="flex items-center gap-1 px-3 py-2 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-all text-sm"
                    >
                      ✏️ <span className="hidden sm:inline">Edit</span>
                    </button>

                    {/* Cancel */}
                    <button
                      onClick={() => {
                        setLoading(true);
                        handleCancel(t.id);
                      }}
                      className="flex items-center gap-1 px-3 py-2 bg-red-50 text-red-600 font-medium rounded-lg hover:bg-red-100 transition-all text-sm"
                    >
                      ❌ <span className="hidden sm:inline">Cancel</span>
                    </button>

                    {/* Close */}
                    <button
                      onClick={() => {
                        setLoading(true);
                        handleClose(t.id);
                      }}
                      className="flex items-center gap-1 px-3 py-2 bg-green-50 text-green-600 font-medium rounded-lg hover:bg-green-100 transition-all text-sm"
                    >
                      ✔️ <span className="hidden sm:inline">Close</span>
                    </button>
                  </div>
                </div>

                {/* Badge Row */}
                <div className="flex flex-wrap gap-2 pt-4 border-t border-gray-100">
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-amber-50 to-amber-100 text-amber-700 text-xs font-semibold px-3 py-1.5 rounded-full border border-amber-200">
                    <span>👤</span> {humanize(t.interaction?.name)}
                  </span>
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-blue-50 to-blue-100 text-blue-700 text-xs font-semibold px-3 py-1.5 rounded-full border border-blue-200">
                    <span>💰</span> {humanize(t.depositType?.name)}
                  </span>
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-emerald-50 to-emerald-100 text-emerald-700 text-xs font-semibold px-3 py-1.5 rounded-full border border-emerald-200">
                    <span>✓</span> {humanize(t.fundingType?.name)}
                  </span>
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-indigo-50 to-indigo-100 text-indigo-700 text-xs font-semibold px-3 py-1.5 rounded-full border border-rose-200">
                    <span>🎯</span> {humanize(t.scope?.name)}
                  </span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
          <div className="bg-white w-full max-w-2xl rounded-2xl shadow-xl p-6">
            {/* Header */}
            <div className="mb-5">
              <h3 className="text-xl font-semibold text-gray-800">
                {editIndex !== null ? "Edit Transaction" : "Add Transaction"}
              </h3>
              <p className="text-sm text-gray-500">
                Enter transaction details clearly for compliance and tracking
              </p>
            </div>

            {/* Form */}
            <div className="grid grid-cols-3 gap-4">
              {/* Client Interaction */}
              <div>
                <Dropdown
                  label="Client Interaction"
                  options={clientInteractionData}
                  onSelect={handleSelectTransactionInteraction}
                  preselectedValue={preselectedClientInteractionType}
                />
              </div>
              {clientInteractionType == 6 && (
                <div className="">
                  <label
                    htmlFor="finInstituition"
                    className="mb-1 text-sm text-labelColour whitespace-normal word-break"
                  >
                    Please specify the client interaction type
                  </label>{" "}
                  <textarea
                    type="text"
                    name="documentId"
                    value={otherClientInteractionType}
                    onChange={(e) => {
                      setOtherClientInteractionType(e.target.value);
                      setForm({
                        ...form,
                        otherClientInteractionType: e.target.value,
                      });
                    }}
                    className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                    placeholder="Add your comments"
                  />
                </div>
              )}
              {/* Transaction Scope */}
              <div>
                <Dropdown
                  label="Transaction Scope"
                  options={transactionScopeData}
                  onSelect={handleSelectTransactionScope}
                  preselectedValue={preselectedTransactionScope}
                />
              </div>
              {transactionScope == 8 && (
                <div className="">
                  <label
                    htmlFor="finInstituition"
                    className="mb-1 text-sm text-labelColour whitespace-normal word-break"
                  >
                    Please specify the transaction scope
                  </label>{" "}
                  <textarea
                    type="text"
                    name="documentId"
                    value={otherTransactionScope}
                    onChange={(e) => {
                      setOtherTransactionScope(e.target.value);
                      setForm({
                        ...form,
                        otherTransactionScope: e.target.value,
                      });
                    }}
                    className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                    placeholder="Add your comments"
                  />
                </div>
              )}
              {/* Deposit Type */}
              <div>
                <Dropdown
                  label="Deposit Type"
                  options={depositTypeData}
                  onSelect={handleSelectDepositType}
                  preselectedValue={preselectedDepositType}
                />
              </div>
              {depositType == 8 && (
                <div className="">
                  <label
                    htmlFor="finInstituition"
                    className="mb-1 text-sm text-labelColour whitespace-normal word-break"
                  >
                    Please specify the deposit type
                  </label>{" "}
                  <textarea
                    type="text"
                    name="documentId"
                    value={depositTypeOther}
                    onChange={(e) => {
                      setDepositTypeOther(e.target.value);
                      setForm({ ...form, depositTypeOther: e.target.value });
                    }}
                    className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                    placeholder="Add your comments"
                  />
                </div>
              )}
              {/* Funding Type */}
              <div>
                <Dropdown
                  label="Funding Type"
                  options={fundingTypeData}
                  onSelect={handleSelectFundingType}
                  preselectedValue={preselectedFundingType}
                />
              </div>

              {fundingType == 3 && (
                <div className="">
                  <label
                    htmlFor="finInstituition"
                    className="mb-1 text-sm text-labelColour whitespace-normal word-break"
                  >
                    Please specify the funding type
                  </label>{" "}
                  <textarea
                    type="text"
                    name="documentId"
                    value={otherFundType}
                    onChange={(e) => {
                      setOtherFundType(e.target.value);
                      setForm({ ...form, otherFundType: e.target.value });
                    }}
                    className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                    placeholder="Add your comments"
                  />
                </div>
              )}
              {/* Currency */}
              <div>
                <Dropdown
                  label="Currency"
                  options={currencyData}
                  search={true}
                  preselectedValue={preselectedcashCurrency}
                  onSelect={handleSelectToCurrency}
                />
              </div>

              {/* Value */}
              <div>
                <label className="text-sm  text-labelColour whitespace-normal word-break">
                  Anticipated total transaction value
                </label>{" "}
                <input
                  id="amount"
                  type="text"
                  value={isFocused ? amount : formatNumber(amount)}
                  ref={inputRef}
                  onChange={(e) => {
                    // Avoid triggering onChange if the focus is on the button
                    if (!isFocused) return;

                    handleAmountChange(e, e.target.value);
                  }}
                  onFocus={() => setIsFocused(true)}
                  onBlur={(e) => {
                    setIsFocused(false);
                  }}
                  className="text-sm mt-2 w-full p-2 text-black border rounded-md text-md"
                  placeholder="$0"
                />
              </div>

              {/* Date */}
              <div>
                <label className="block mb-1 w-full text-sm text-labelColour">
                  Expected Transaction Date
                </label>
                <input
                  type="date"
                  value={creationDate}
                  onChange={(e) => {
                    setCreationDate(e.target.value);
                    setForm({ ...form, completionDate: e.target.value });
                  }}
                  min={getCurrentDate()}
                  className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                />
              </div>

              {/* Description */}
              <div className="">
                <label
                  htmlFor="finInstituition"
                  className="mb-1 text-sm text-labelColour"
                >
                  Transaction Description
                </label>{" "}
                <textarea
                  type="text"
                  name="documentId"
                  value={comments}
                  onChange={(e) => {
                    setComments(e.target.value);
                    setForm({ ...form, description: e.target.value });
                  }}
                  className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                  placeholder="Add your comments"
                />
              </div>

              {/* Address */}
              <div className="">
                <label
                  htmlFor="finInstituition"
                  className="mb-1 text-sm text-labelColour"
                >
                  Property Address
                </label>{" "}
                <AddressAutocomplete
                  value={
                    redAddress?.value?.full || apIAddress?.google_address || ""
                  }
                  disabled={redAddress.status == "approved"}
                  className={
                    redAddress.status == "rejected"
                      ? "border-[#FF5050] border-2 w-full"
                      : "w-full"
                  }
                  onSelect={(addr) => {
                    if (!addr) return;

                    const fullAddress =
                      addr.full || addr.label || addr.google_address || "";

                    setApIAddress(null);

                    setRedAddress({
                      ...redAddress,
                      value: addr,
                    });

                    setForm({
                      ...form,
                      address: fullAddress,
                    });
                  }}
                />
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-between items-center mt-6">
              <button
                onClick={() => {
                  setIsOpen(false);
                  setEditIndex(null);
                  setForm(defaultForm);
                  setAmount("");
                  setComments("");
                  setCreationDate(getCurrentDate());
                  setRedAddress({});
                  setApIAddress(null);
                  setpreselectedClientInteractionType({});
                  setpreselectedTransactionScope({});
                  setpreselectedDepositType({});
                  setpreselectedFundingType({});
                  setpreselectedCurrency({
                    value: defaultForm.currency,
                    label: "AUD",
                  });
                  setOtherClientInteractionType("");
                  setOtherTransactionScope("");
                  setDepositTypeOther("");
                  setOtherFundType("");
                }}
                className="text-gray-500 hover:text-gray-700 text-sm"
              >
                Cancel
              </button>

              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(e);
                }}
                className="bg-gradient-to-r from-gray-900 to-gray-700 text-white px-5 py-2 rounded-lg shadow hover:opacity-90 transition"
              >
                {editIndex !== null ? "Update Transaction" : "Save Transaction"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* View Modal */}
      {viewItem && (
        <div className="fixed inset-0 bg-gradient-to-br from-black/40 to-black/20 backdrop-blur-md flex justify-center items-center z-50 p-4">
          <div className="bg-white  h-[90vh] text-sm rounded-xl shadow-2xl max-w-2xl w-full overflow-auto">
            {/* Header with Gradient */}
            <div className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 p-8 text-white">
              <h2 className="text-2xl font-bold mb-2">Transaction Details</h2>
              <p className="text-slate-300 text-sm">
                Complete overview of your transaction
              </p>
            </div>

            {/* Content */}
            <div className="p-8 text-sm">
              {/* Transaction Amount Section */}
              <div className="mb-8 pb-8 border-b border-gray-200">
                <div className="flex items-end gap-4">
                  <div>
                    <p className="text-gray-500 text-sm font-medium mb-2">
                      Transaction Amount
                    </p>
                    <h3 className="text-2xl font-bold text-slate-900">
                      {viewItem.symbol}
                      {formatNumber(viewItem.value)}
                    </h3>
                  </div>
                  <div className="ml-auto">
                    <span className="inline-block bg-gradient-to-r from-emerald-50 to-blue-50 text-emerald-700 text-sm font-semibold px-4 py-2 rounded-lg border border-emerald-200">
                      {viewItem.currency}
                    </span>
                  </div>
                </div>
              </div>

              {/* Transaction Details Grid */}
              <div className="grid grid-cols-2 gap-6 mb-8">
                {/* Interaction */}
                <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 p-4 rounded-xl border border-blue-200">
                  <p className="text-blue-600 text-xs font-semibold uppercase tracking-wider mb-1">
                    Client Interaction
                  </p>
                  <p className="text-slate-900 font-semibold text-md">
                    {viewItem.interaction_enum
                      ? capitalizeWords(viewItem.interaction)
                      : capitalizeWords(
                          viewItem.otherClientInteractionType ||
                            viewItem.interaction,
                        )}
                  </p>
                  {viewItem.interaction_enum &&
                    viewItem.otherClientInteractionType && (
                      <p className="text-sm text-gray-500 mt-1">
                        Other: {viewItem.otherClientInteractionType}
                      </p>
                    )}
                </div>

                {/* Scope */}
                <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 p-4 rounded-xl border border-purple-200">
                  <p className="text-purple-600 text-xs font-semibold uppercase tracking-wider mb-1">
                    Transaction Scope
                  </p>
                  <p className="text-slate-900 font-semibold text-md">
                    {viewItem.scope_enum
                      ? capitalizeWords(viewItem.scope)
                      : capitalizeWords(
                          viewItem.otherTransactionScope || viewItem.scope,
                        )}
                  </p>
                  {viewItem.scope_enum && viewItem.otherTransactionScope && (
                    <p className="text-sm text-gray-500 mt-1">
                      Other: {viewItem.otherTransactionScope}
                    </p>
                  )}
                </div>

                {/* Deposit Type */}
                <div className="bg-gradient-to-br from-amber-50 to-amber-100/50 p-4 rounded-xl border border-amber-200">
                  <p className="text-amber-600 text-xs font-semibold uppercase tracking-wider mb-1">
                    Deposit Type
                  </p>
                  <p className="text-slate-900 font-semibold text-md">
                    {viewItem.depositType_enum
                      ? capitalizeWords(viewItem.depositType)
                      : capitalizeWords(
                          viewItem.depositTypeOther || viewItem.depositType,
                        )}
                  </p>
                  {viewItem.depositType_enum && viewItem.depositTypeOther && (
                    <p className="text-sm text-gray-500 mt-1">
                      Other: {viewItem.depositTypeOther}
                    </p>
                  )}
                </div>

                {/* Funding Type */}
                <div className="bg-gradient-to-br from-teal-50 to-teal-100/50 p-4 rounded-xl border border-teal-200">
                  <p className="text-teal-600 text-xs font-semibold uppercase tracking-wider mb-1">
                    Funding Type
                  </p>
                  <p className="text-slate-900 font-semibold text-md">
                    {viewItem.fundingType_enum
                      ? capitalizeWords(viewItem.fundingType)
                      : capitalizeWords(
                          viewItem.otherFundType || viewItem.fundingType,
                        )}
                  </p>
                  {viewItem.fundingType_enum && viewItem.otherFundType && (
                    <p className="text-sm text-gray-500 mt-1">
                      Other: {viewItem.otherFundType}
                    </p>
                  )}
                </div>
              </div>

              {/* Date Section */}
              <div className="mb-8">
                <div className="bg-gray-50 p-4 rounded-xl">
                  <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-2">
                    Transaction Date
                  </p>
                  <p className="text-slate-900 font-semibold text-md">
                    {viewItem.completionDate}
                  </p>
                </div>
              </div>

              {/* Description Section */}
              {viewItem.description && (
                <div className="mb-8">
                  <div className="bg-gray-50 p-4 rounded-xl">
                    <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-2">
                      Description
                    </p>
                    <p className="text-slate-900 text-base leading-relaxed">
                      {viewItem.description}
                    </p>
                  </div>
                </div>
              )}

              {/* Address Section */}
              {viewItem.address && (
                <div className="mb-8">
                  <div className="bg-gray-50 p-4 rounded-xl">
                    <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-2">
                      Property Address
                    </p>
                    <p className="text-slate-900 text-base leading-relaxed">
                      {viewItem.address}
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Action Buttons */}
            <div className="flex gap-3 p-8 bg-gray-50 border-t border-gray-200">
              <button
                onClick={() => setViewItem(null)}
                className="flex-1 px-4 py-3 text-gray-700 font-semibold border-2 border-gray-300 rounded-lg hover:bg-gray-100 transition-all duration-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}